import React, { useEffect, useState } from "react";
import { Alert, Grid } from "@mui/material";
import { useForm } from "react-hook-form";
import BackButton from "../BackButton";
import InputTextFieldGrid from "../common/InputTextFieldGrid";
import CheckboxFieldGrid from "components/common/CheckboxFieldGrid";
import { validatePermission } from "helpers/authentication";
import CustomButton from "components/CustomButton";
import { useNavigate } from "react-router-dom";
import TableData from "components/common/TableData";

const CredProductForm = ({ title, subtitle, defaultValues, submit, type, fixedAmount }) => {
  const navigate = useNavigate();
  const [error, setError] = useState(false)
  const { control, handleSubmit, setValue, watch } = useForm({ defaultValues });
  const { amounts } = watch();

  useEffect(() => {
    setError(false);
  }, [amounts])

  const setAmountValue = (value, index, col) => {
    setValue('amounts', amounts.map((item, i) => {
      if (i === index) {
        return {
          ...item,
          [col]: value
        }
      }
      return item;
    }))
  }
  const validate = () => {
    if (type !== 'pds' && fixedAmount && amounts.every(item => !item.sku || item.sku === '')) {
      setError('Debes agregar el SKU de al menos un monto')
      return;
    }
    handleSubmit(submit)();
  };

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <div>
          <BackButton click={() => navigate('..')} />
        </div>
        <div className="container-title">
          <div className="title">{title}</div>
          <div className="subtitle">{subtitle}</div>
        </div>
        <div style={{ width: "170px" }}></div>
      </Grid>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <Grid
          container
          direction="row"
          m={"40px"}
          maxWidth={"70%"}
          justifyContent="center"
          spacing={3}
        >
          {
            type === 'pds' ? (
              <>
                {
                  fixedAmount ? (
                    <Grid item xs={12}>
                      <TableData
                        dataRows={amounts || []}
                        dataTitle={["Monto", "Etiqueta", "SKU HEBE", "SKU Proveedor"]}
                        pagination={false}
                        formatter={({ amount, hebe_sku, sku, label }, i) => [
                          amount,
                          label || '-',
                          hebe_sku || '-',
                          {
                            name: "sku",
                            type: "input",
                            value: sku,
                            onBlur: (value) => setAmountValue(value, i, 'sku'),
                            onEnter: (value) => setAmountValue(value, i, 'sku')
                          },
                        ]}
                      />
                    </Grid>
                  ) : (
                    <InputTextFieldGrid
                      xs={12}
                      name={"sku"}
                      control={control}
                      required={"Debes agregar el nombre"}
                      label={"SKU"}
                    />
                  )
                }
                <CheckboxFieldGrid
                  xs={4}
                  name={'inline'}
                  control={control}
                  label={'En linea'}
                />
                <CheckboxFieldGrid
                  xs={4}
                  name={'partialPayments'}
                  control={control}
                  label={'Pagos parciales'}
                />
                <CheckboxFieldGrid
                  xs={4}
                  name={'balanceInquiry'}
                  control={control}
                  label={'Consulta de saldo'}
                />
                {
                  validatePermission('proveedores', 'comisiones', ['ver']) && <InputTextFieldGrid
                    xs={4}
                    name={"commissionProvider"}
                    control={control}
                    label={"Comisión proveedor"}
                    inputType={"number"}
                    disabled={!validatePermission('proveedores', 'comisiones', ['agregar', 'editar'])}
                  />
                }
                {/* <InputTextFieldGrid
                  xs={4}
                  name={"commissionChannel"}
                  control={control}
                  label={"Comisión canal"}
                  inputType={"number"}
                /> */}
                {/* {
                  validatePermission('proveedores', 'comisiones', ['ver']) && <InputTextFieldGrid
                    xs={4}
                    name={"commissionUserMax"}
                    control={control}
                    label={"Comisión máxima usuario"}
                    inputType={"number"}
                    disabled={!validatePermission('proveedores', 'comisiones', ['agregar', 'editar'])}
                  />
                } */}
              </>
            ) : (
              <>
                {
                  fixedAmount ? (
                    <Grid item xs={12}>
                      <TableData
                        dataRows={amounts || []}
                        dataTitle={["Monto", "Etiqueta", "SKU HEBE", "SKU Proveedor"]}
                        pagination={false}
                        formatter={({ amount, hebe_sku, sku, label }, i) => [
                          amount,
                          label || '-',
                          hebe_sku || '-',
                          {
                            name: "sku",
                            type: "input",
                            value: sku,
                            onBlur: (value) => setAmountValue(value, i, 'sku'),
                            onEnter: (value) => setAmountValue(value, i, 'sku')
                          },
                        ]}
                      />
                    </Grid>
                  ) : (
                    <InputTextFieldGrid
                      xs={12}
                      name={"sku"}
                      control={control}
                      required={"Debes agregar el nombre"}
                      label={"SKU"}
                    />
                  )
                }

              </>
            )
          }
          {
            error && <Grid item xs={12}>
              <Alert severity="error">{error}</Alert>
            </Grid>
          }
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <CustomButton
            click={validate}
            name={"Guardar"}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default CredProductForm;
